'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _url = require('../../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @param {Object} trackingCode - The referral code.
 * @returns {Object} - The transformed values.
 */
exports.default = function (formValues) {
  var signature = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var additional_data = formValues.application.additional_data;


  if (signature) additional_data.signature = signature;

  return {
    additional_data: _extends({}, additional_data)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/msh/global2go/questionnaire.js
// module id = 822
// module chunks = 0